import ComponentMenuPanel from './componentMenuPanel.container'

export default ComponentMenuPanel